import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { getData, addData, updateData, deleteData } from '../../services/webinarProgramServices';
import { Button, Modal, Form } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import Sidebar from '../../components/Layout/Sidebar';
import Spinner from '../../components/Spinner';
import { toast } from 'react-toastify';
import { validateFile} from '../../utils/validators';


const Webinarprogram = () => {
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    w_year: '',
    uploadedfile: null,
  });
  const [modalType, setModalType] = useState(''); // 'add' or 'edit'
  const [showModal, setShowModal] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setselectedData] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({}); 
  

  // Fetch data from API
  const fetchData = useCallback(async () => {
    try{
    setLoading(true);
    const response = await getData();
    setData(response.data);
    }
    catch (error) {
      console.error('Error fetching data:', error);
    }
    finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

    //validate the form 
    const validateForm = () => {
    const newErrors = {};
    if (!formData.w_year) newErrors.w_year = "Order is required";
    if (!formData.uploadedfile && formData.uploadedfile === null) {
    if (!errors.uploadedfile) newErrors.uploadedfile = "Upload webinar Program PDF  is required";
  }
   setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };
  

  const handleChange = async(e) => {
    try{
        const { name, value, files } = e.target;
        const file = files?.[0]
          // Create a copy of the current form data
          let updatedData = { ...formData };
          let updatedErrors = { ...errors };
          if (file) {
            const isPDF = file.type === "application/pdf";
            if (!isPDF) {
              setErrors((prev) => ({
                ...prev,
                [name]: "Only PDF files are allowed.",
              }));
              return;
            }
              const fileType = file.type.includes("image") ? "img" : "pdf";
              const isValid = await validateFile(file, setErrors,name,fileType);
              if (isValid) {
                updatedData[name] = file;
                updatedErrors[name] = '';
              }
              else{
                return ; // Don't update if invalid
              }
        } 
          else{
          updatedData[name] = value;
          if (value) {
          updatedErrors[name] = ''; // Clear error if corrected
        }}
        setFormData(updatedData);
        setErrors(updatedErrors);
      }
      catch (error) {
      console.error("Error in handleChange:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validate form data
      if (!validateForm()) {
          return
        }
    try{
    const form = new FormData();
    form.append('id', formData.id);
    form.append('w_year', formData.w_year);
    form.append('uploadedfile', formData.uploadedfile);


    if (modalType === 'add') {
      const result = await addData(form);
      if (result.status === 200) {
        fetchData();
        setShowModal(false);
        toast.success("Saved Successfully!", {position: 'top-right',});
      } else {
       toast.error(result.message ||"Failed to Added data. Please try again.", {position: 'top-right',});
      }
    } else if (modalType === 'edit') {
      const result = await updateData(form);
      if (result.status === 200) {
        fetchData();
        setShowModal(false);
        toast.success("Updated Successfully!", {position: 'top-right',});
      } else {
         toast.error(result.message ||"Failed to update data. Please try again.", {position: 'top-right',});
      }
    }
  }
  catch (error) {
        console.error("Error during form submission:", error);
    }
  };

  const handleDelete = async () => {
    try{
    if (selectedData) {
      const result = await deleteData(selectedData.id);
      if (result.status === 200) {
        fetchData();
        setShowDeleteConfirmModal(false);
         toast.success("Deleted Successfully!", { position: 'top-right',});
      } else {
         toast.error(result.message ||"Failed to Delete data. Please try again.", {position: 'top-right',});
      }
    }
  }
   catch(error){
      console.log("Failed to delete getData")
    }
  };

  const openModal = (type, data = { id: null, w_year: '', uploadedfile: null }) => {
    setModalType(type);
    setFormData(data);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const openDeleteConfirmModal = (data) => {
    setselectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const closeDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
    setselectedData(null);
  };
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

// Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    const filtered =  data.filter(
      (data) =>
      data.w_year.toLowerCase().includes(searchText.toLowerCase()) 
    );
    const sortedData = [...filtered].sort((a, b) => new Date(b.w_year) - new Date(a.w_year));
    return sortedData;
  }, [data
    , searchText]);

  const columns = [
    {
        name: '#',
        selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
        sortable: false,
        width: '80px',
      },
      {
        name: 'Year',
        selector: (row) => row.w_year,
        sortable: true,
      },
      {
        name: 'PDF',
        selector: row => row.web_program,
        sortable: true,
        cell: row => row.web_program ? (
            <a className="btn btn-sm bg-success text-light rounded" href={row.web_program} target="_blank" rel="noopener noreferrer">
                <i className="mdi mdi-arrow-down-bold text-light"></i> Download
            </a>
        ) : 'No PDF Available',
    },
    

    {
      name: 'Actions',
      cell: (row) => (
        <div>
          <Button
            className="me-2"
            variant="warning"
            size="sm"
            onClick={() => openModal('edit', {
              id: row.id,
              w_year: row.w_year,
              uploadedfile: row.web_program,
            })}
          >
            Edit
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => openDeleteConfirmModal(row)}
          >
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col-8">
              <p className='mb-3 fs-4'>Basic Setup & File upload <b>/ Webinar Program</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3 form-label-custom" onClick={() => openModal('add')}>
                Add
              </button>
            </div>
          </div>
          

          {/* Data Table for data */}
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            search
            highlightOnHover
            responsive
            striped
            paginationPerPage={10}
            paginationComponentOptions={{
            noRowsPerPage: true,
          }}
          onChangePage={handlePageChange}
          subHeader
          subHeaderComponent={
              <div>
              <input className="form-control" type="text" placeholder="Search" value={searchText}
                  onChange={handleSearchChange}
              />
              </div>
          }
          />

        {/* Modal for Add/Edit data */}
        <Modal show={showModal} onHide={closeModal} backdrop="static">
          <Modal.Header closeButton>
            <Modal.Title className='fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className='form-label-custom'>Order <small className='text-danger'> * </small></Form.Label>
                  <Form.Control
                      type="month"
                      name="w_year"
                      value={formData.w_year}
                      onChange={handleChange}
                      isInvalid ={!!errors.w_year}
                  />
                  <Form.Control.Feedback type="invalid">{errors.w_year}</Form.Control.Feedback>
                  </Form.Group>
              
              <Form.Group className="mb-3">
                <Form.Label className='form-label-custom'>
                Upload webinar Program PDF <small className='text-danger'> * </small> <small className='text-primary'>(Upload file size should be less than 8mb) </small>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="uploadedfile"
                  onChange={handleChange}
                  isInvalid={!!errors.uploadedfile}   
                  accept="application/pdf"                 
                />
                <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>
              </Form.Group>
              <Modal.Footer className='border-0'>
                <Button variant="secondary" onClick={closeModal}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit">
                  {modalType === 'add' ? 'Add' : 'Save'}
                </Button>
              </Modal.Footer>
            </Form>
          </Modal.Body>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
          <Modal.Header closeButton>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to delete this row?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeDeleteConfirmModal}>
              Cancel
            </Button>
            <Button variant="danger" onClick={handleDelete}>
              Yes, Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <Footer />
      </div>
      )}
      </div>
    </div>
  );
};

export default Webinarprogram;